import React from "react";
import styled from "styled-components";

const FloatingWhatsapp = styled.a`
  position: fixed;
  right: clamp(1rem, 2vw, 2rem);
  bottom: clamp(1rem, 2vw, 2rem);
  z-index: 45;
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  min-height: 3.6rem;
  padding: 0.8rem 1.1rem 0.8rem 0.9rem;
  border-radius: 999px;
  background: linear-gradient(135deg, #1c9f4f, #25d366);
  color: #ffffff;
  font-size: 0.96rem;
  font-weight: 700;
  text-decoration: none;
  box-shadow: 0 20px 36px rgba(20, 147, 72, 0.32);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    color: #ffffff;
    box-shadow: 0 22px 40px rgba(20, 147, 72, 0.38);
  }

  @media (max-width: 560px) {
    min-height: 3.2rem;
    padding-right: 0.95rem;
    font-size: 0.9rem;
  }
`;

const IconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.1rem;
  height: 2.1rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  flex-shrink: 0;
`;

function WppBtn() {
  return (
    <FloatingWhatsapp
      href="https://wa.me/5584999284464"
      target="_blank"
      rel="noreferrer"
      aria-label="Fale com JR Figurinhas no WhatsApp"
    >
      <IconWrap aria-hidden="true">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 32 32"
          fill="currentColor"
        >
          <path d="M12.01 2C6.504 2 2.022 6.478 2.02 11.984c0 1.76.46 3.478 1.334 4.992L2 22l5.232-1.236A9.97 9.97 0 0 0 12.006 22h.004c5.505 0 9.985-4.48 9.988-9.984A9.92 9.92 0 0 0 19.076 4.95 9.92 9.92 0 0 0 12.011 2Zm-.002 2c2.136.001 4.143.834 5.652 2.342a7.95 7.95 0 0 1 2.336 5.65c-.002 4.404-3.584 7.986-7.99 7.986a7.96 7.96 0 0 1-3.816-.97l-.674-.367-.744.176-1.969.464.48-1.785.217-.801-.414-.719a7.95 7.95 0 0 1-1.066-3.992c.002-4.402 3.585-7.984 7.988-7.984Zm-3.533 3.375c-.167 0-.437.062-.666.312-.229.249-.875.852-.875 2.08 0 1.228.895 2.415 1.02 2.582.124.166 1.727 2.766 4.264 3.766 2.108.831 2.536.667 2.994.625.458-.041 1.478-.603 1.686-1.186.208-.583.208-1.085.146-1.188-.062-.104-.229-.166-.479-.291-.249-.125-1.476-.728-1.705-.811-.229-.083-.396-.125-.562.125-.166.25-.643.811-.789.977-.146.167-.291.189-.541.064-.25-.126-1.054-.39-2.008-1.24-.742-.661-1.243-1.477-1.389-1.727-.145-.249-.014-.386.111-.51.112-.112.248-.291.373-.437.124-.146.167-.25.25-.416.083-.166.04-.313-.021-.438-.062-.125-.548-1.358-.77-1.852-.187-.415-.384-.425-.562-.432-.145-.006-.311-.006-.477-.006Z" />
        </svg>
      </IconWrap>
      <span>Fale no WhatsApp</span>
    </FloatingWhatsapp>
  );
}

export default WppBtn;
